import { FormHandles } from '@unform/core';
import React, { createRef, FC } from 'react';
import ComponentConfiguracaoEscala from './Component';
import { useMutationPeriodo } from './hooks/useMutationPeriodo';
import { useQueryPeriodo } from './hooks/useQueryPeriodo';
const PageConfiguracaoEscala: FC = () => {
    const { inputs, loading: loadingData } = useQueryPeriodo();
    const { loading, atualizaPeriodo } = useMutationPeriodo();

    const rForm = createRef<FormHandles>();

    const oProps = {
        rForm,
        inputs,
        loading,
        loadingData,
        handleSubmit: atualizaPeriodo,
    };
    return <ComponentConfiguracaoEscala {...oProps} />;
};
export default PageConfiguracaoEscala;
